// TODO make it more efficient: expire cache only when ckeditor
// files are modified
window.CKEDITOR.timestamp = window.__HB_ENV__.CKEDITOR_TIMESTAMP;
